/**
 * The item at `from`, moved to `to`, in a new array. Out-of-range indices
 * return the list unchanged — a drop that lands nowhere must not drop an item.
 */
export const moveItem = <T>(
  items: readonly T[],
  from: number,
  to: number,
): T[] => {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= items.length ||
    to >= items.length
  ) {
    return [...items];
  }
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};
